import { routerType } from "../types/router.types";
import Vorur from "./Braud";
import Home from "./Home";
import Pantanir from "./Pantanir";
import Runstykki from "./Runstykki";
import Bakkelsi from "./Bakkelsi";
import Kokur from "./Kokur";
import HafaSamband from "./Hafa_samband";
import UmOkkur from "./Um_Okkur";
import Smurt from "./Smurt";
import Myndaalbum from "./MyndaAlbum";
import React from "react";
import PontunSmarettirModal from "./Smarettir";
import Karfa from "./Karfa";
import OrderSuccess from "./Success-Fail/OrderSuccess";
import OrderError from "./Success-Fail/OrderError";

const pagesData: routerType[] = [
  {
    path: "",
    element: <Home />,
    title: "home"
  },
  {
    path: "vorur",
    element: <Vorur />,
    title: "vörur"
  }, 
  {
    path: "kokur",
    element: <Kokur/>,
    title: "Kökur"
  },
  {
    path: "umokkur",
    element: <UmOkkur/>,
    title: "um okkur"
  },
  {
    path: "hafa-samband",
    element: <HafaSamband/>,
    title: "samband"
  },
  {
    path: "pantanir",
    element: <Pantanir />,
    title: "pantanir"
  },
  {
    path: "braud",
    element: <Vorur />,
    title: "brauð"
  },
  {
    path: "braudmeti",
    element: <Runstykki/>,
    title: "brauðmeti"
  },
  {
    path: "bakkelsi",
    element: <Bakkelsi/>,
    title: "bakkelsi"
  },
  {
    path: "smurt",
    element: <Smurt/>,
    title: "smurt"
  },
  {
    path: "myndaalbum",
    element: <Myndaalbum/>,
    title: "myndaalbum"
  },
  {
    path: "smarettir",
    element: <PontunSmarettirModal />,
    title: "smarettir"
  },
  {
    path: "karfa",
    element: <Karfa />,
    title: "karfa"
  },
  {
    path: "order/success",
    element: <OrderSuccess />,
    title: "order success"
  },
  {
    path: "order/error",
    element: <OrderError />,
    title: "order error"
  }
];

export default pagesData;